import React from 'react';

const InfoBox = props => {
  const { headline, subline, icon, isHeadlineOnTop = true } = props;

  return (
    <div className="onboarding-new__info-box">
      {isHeadlineOnTop && (
        <h1 className="onboarding-new__headline">{headline}</h1>
      )}
      {icon}
      {!isHeadlineOnTop && (
        <h1 className="onboarding-new__headline--bottom">{headline}</h1>
      )}
      {subline && <p className="onboarding-new__subline">{subline}</p>}
      {props.children}
    </div>
  );
};

export default InfoBox;



// WEBPACK FOOTER //
// ./src/components/new/onboarding/InfoBox.js